import { render } from "./recommand_detail.vue?vue&type=template&id=3acdabc2&scoped=true"
import script from "./recommand_detail.vue?vue&type=script&lang=js"
export * from "./recommand_detail.vue?vue&type=script&lang=js"

import "./recommand_detail.vue?vue&type=style&index=0&id=3acdabc2&lang=less&scoped=true"

import exportComponent from "D:\\微客\\we_customer_guide\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3acdabc2"]])

export default __exports__